// Order mirrors the CE desktop dialogs. API-only rows are listed in
// API_GROUP_RESOURCE_KEYS, Field-only rows in FIELD_GROUP_RESOURCE_KEYS.
export const FILTERABLE_RESOURCES = [
  {
    // CE has no filters for API Time/Expenses (NoFilterTable): All/None plus
    // "Enable Inbound", same as Subcontracts.
    key: "apitime",
    label: "Time Entries",
    hasFilterModal: false,
    hasActiveMode: false,
    supportsFiltered: false,
    hasInboundToggle: true,
  },
  {
    key: "apiexpenses",
    label: "Expenses",
    hasFilterModal: false,
    hasActiveMode: false,
    supportsFiltered: false,
    hasInboundToggle: true,
  },
  { key: "jobs", label: "Jobs", hasFilterModal: true, hasActiveMode: true },
  {
    // Legacy CE defines no filterable fields for Subcontracts
    // (CAPIFilterSettings_APISubcontractEntries is VALUES(0)/FLAGS(0)) and
    // the row only appears in the API-key group dialog, not the user Access
    // Group dialog — so unlike every other resource here, there's no
    // Filtered mode or modal, just All/None plus an "Enable Inbound" toggle
    // carried over from that same CE dialog row.
    key: "subcontracts",
    label: "Subcontracts",
    hasFilterModal: false,
    hasActiveMode: false,
    supportsFiltered: false,
    hasInboundToggle: true,
  },
  {
    key: "jcct",
    label: "Cost Types",
    hasFilterModal: true,
    hasActiveMode: false,
  },
  {
    key: "employees",
    label: "Employees",
    hasFilterModal: true,
    hasActiveMode: true,
  },
  {
    key: "equipment",
    label: "Equipment",
    hasFilterModal: true,
    hasActiveMode: true,
  },
  {
    key: "prdept",
    label: "Payroll Departments",
    hasFilterModal: true,
    hasActiveMode: false,
  },
  {
    key: "prclass",
    label: "Worker Classes",
    hasFilterModal: true,
    hasActiveMode: false,
  },
  {
    key: "absence_codes",
    label: "Absence Codes",
    hasFilterModal: true,
    hasActiveMode: false,
  },
  {
    key: "prunion",
    label: "Payroll Unions",
    hasFilterModal: true,
    hasActiveMode: false,
  },
  {
    key: "prwcomp",
    label: "Worker Comp Codes",
    hasFilterModal: true,
    hasActiveMode: false,
  },
  {
    key: "wloc",
    label: "Work Locations",
    hasFilterModal: true,
    hasActiveMode: false,
  },
  {
    key: "expense_types",
    label: "Expense Types",
    hasFilterModal: true,
    hasActiveMode: false,
  },
  {
    key: "field_logs",
    label: "Field Logs",
    hasFilterModal: true,
    hasActiveMode: false,
  },
  {
    key: "inv",
    label: "Inventory Items",
    hasFilterModal: true,
    hasActiveMode: true,
  },
  {
    key: "ven",
    label: "Vendors",
    hasFilterModal: true,
    hasActiveMode: true,
  },
  {
    key: "svcwrko",
    label: "Service Work Orders",
    hasFilterModal: true,
    hasActiveMode: false,
  },
];

// These rows appear only in API groups.
export const API_GROUP_RESOURCE_KEYS = [
  "apitime",
  "apiexpenses",
  "subcontracts",
  "prunion",
  "prwcomp",
];

// Work Locations and Field Logs appear only in Field groups.
export const FIELD_GROUP_RESOURCE_KEYS = ["wloc", "field_logs"];

// Tag style for a resource's filter mode: all/active look solid, filtered is
// outlined, none is greyed out.
export function getFilterTagModifier(mode) {
  return mode === "filtered" || mode === "none" ? mode : "all";
}

// Resources a group grants access to, in display order. Mode "none" is
// dropped; getFilter(key) returns the filter record for a resource.
export function getEnabledResources(resources, getFilter) {
  return resources.flatMap((resource) => {
    const mode = getFilter(resource.key)?.mode;
    return mode && mode !== "none" ? [{ resource, mode }] : [];
  });
}

export function getVisibleResources(groupType) {
  return FILTERABLE_RESOURCES.filter((r) =>
    groupType === "api"
      ? !FIELD_GROUP_RESOURCE_KEYS.includes(r.key)
      : !API_GROUP_RESOURCE_KEYS.includes(r.key)
  );
}
